import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import LayoutBox from './layout_box';

const LayoutBoxScrolls = ({ className, ...props }) => (
  <LayoutBox className={classnames('l__flexes-to-1 l__scrolls', props.className)} {...props} />
);

LayoutBoxScrolls.propTypes = {
  className: PropTypes.string,
};

export default LayoutBoxScrolls;
